import type { ButtonProps } from 'antd';

import { Button } from '../Ant';
import { PinnedFormActions } from '../../assets/styles/components/formCard.styled';

/** A form's primary action, which stays in view at the bottom of the pane while the fields scroll. */
const PinnedSaveButton: React.FC<ButtonProps> = (props) => (
  <PinnedFormActions>
    <Button size="large" block type="primary" {...props} />
  </PinnedFormActions>
);

export default PinnedSaveButton;
